import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import axios from 'axios';
import {
  Dialog,
  DialogContent,
  Typography,
  Tooltip,
  Button,
  Snackbar,
  SnackbarContent,
  IconButton,
} from '@material-ui/core';
import { MdClose } from 'react-icons/lib/md';
import _ from 'lodash';

import blockProps from '../../utils/blockProps';
import FormBuilder from '../FormBuilder';
import Loader from '../Loader';

class ModalForm extends React.Component {
  static propTypes = {
    apiEndpoint: PropTypes.string.isRequired,
    method: PropTypes.oneOf(['post', 'put']),
    trigger: PropTypes.node.isRequired,
    tooltipTitle: PropTypes.string,
    onClose: PropTypes.func,
    onSuccess: PropTypes.func,
  };

  static defaultProps = {
    method: 'post',
    tooltipTitle: '',
    onClose: () => {},
    onSuccess: () => {},
  };

  state = {
    dataLoaded: false,
    data: null,
    error: null,
    modalOpened: false,
    submittingForm: false,
    snackbarOpened: false,
    snackbarMessage: '',
    formError: false,
    formErrorMessages: {},
  };

  async componentDidMount() {
    try {
      const {
        data: { data },
      } = await axios.options(this.props.apiEndpoint);

      this.setState({ dataLoaded: true, data });
    } catch (error) {
      this.setState({ dataLoaded: true, error: error.message });
    }
  }

  clearFormErrorForField = (field) => {
    this.setState(state => ({
      formErrorMessages: _.omit(state.formErrorMessages, [field]),
    }));
  };

  handleModalOpened = () => {
    this.setState({ modalOpened: true });
  };

  handleModalClose = () => {
    this.setState({ modalOpened: false }, () => {
      this.props.onClose();
    });
  };

  handleSnackbarClose = () => {
    this.setState({
      snackbarOpened: false,
      snackbarMessage: '',
      formError: false,
    });
  };

  submitForm = async (formData) => {
    this.setState({ submittingForm: true });
    try {
      const { data } = await axios[this.props.method](this.props.apiEndpoint, formData);
      const response = data.data || {};

      this.setState(
        {
          submittingForm: false,
          snackbarOpened: true,
          snackbarMessage: response.message || 'successfully submitted',
        },
        () => {
          this.props.onSuccess();
          this.handleModalClose();
        },
      );
    } catch (error) {
      const errorMessages = _.get(error, 'response.data.data.errors');
      this.setState({
        submittingForm: false,
        formError: true,
        formErrorMessages: errorMessages || {},
        snackbarOpened: true,
        snackbarMessage: 'something went wrong',
      });
    }
  };

  render() {
    const { trigger, tooltipTitle } = this.props;

    return [
      <Tooltip key="trigger-node" title={tooltipTitle}>
        {React.cloneElement(trigger, {
          onClick: this.handleModalOpened,
          style: {
            cursor: 'pointer',
          },
        })}
      </Tooltip>,
      <div key="modal-form">
        <Dialog open={this.state.modalOpened} onClose={this.handleModalClose} fullWidth>
          <DialogContent>
            {!this.state.dataLoaded ? (
              <Typography variant="body2" color="secondary">
                Loading...
              </Typography>
            ) : this.state.error ? (
              <Typography variant="body1" color="error">
                {this.state.error}
              </Typography>
            ) : (
              <FormBuilder
                errors={this.state.formErrorMessages}
                clearErrorForField={this.clearFormErrorForField}
                config={this.state.data}
                renderFormActions={({ validateForm, formData }) => (
                  <ButtonContainer>
                    <Button color="primary" onClick={this.handleModalClose}>
                      Close
                    </Button>
                    <Button
                      color="primary"
                      onClick={() => {
                        if (validateForm(formData)) {
                          this.submitForm(formData);
                        }
                      }}
                    >
                      Submit
                    </Button>
                  </ButtonContainer>
                )}
              />
            )}
          </DialogContent>
        </Dialog>

        <Snackbar
          open={this.state.snackbarOpened}
          autoHideDuration={3000}
          onClose={this.handleSnackbarClose}
        >
          <StyledSnackbarContent
            formError={this.state.formError}
            message={this.state.snackbarMessage}
            action={[
              <IconButton
                key="close"
                aria-label="Close"
                color="inherit"
                onClick={this.handleSnackbarClose}
              >
                <MdClose size={20} />
              </IconButton>,
            ]}
          />
        </Snackbar>

        {this.state.submittingForm && <Loader />}
      </div>,
    ];
  }
}

export default ModalForm;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 30px;

  & > * + * {
    margin-left: 20px;
  }
`;

const StyledSnackbarContent = styled(blockProps(SnackbarContent, ['formError']))`
  background-color: ${props => (props.formError ? 'red' : 'green')} !important;
`;



// WEBPACK FOOTER //
// ./src/components/ModalForm/ModalForm.js